import Switch from 'antd/lib/switch'
import './index.less'

export default Switch



// WEBPACK FOOTER //
// ./src/elements/switch/index.js